import { queryOptions } from "@tanstack/react-query";
import { getElprisReport } from "@/lib/elprisReport.functions";

/**
 * Datafrågan för rapporten "Elpriset i Sverige". Ligger i en egen modul så att
 * ruttens loader kan använda den utan att dra in själva sidan (och recharts)
 * i huvudpaketet som laddas på alla sidor.
 */
export const elprisReportQuery = queryOptions({
  queryKey: ["public-elpris-report"],
  queryFn: () => getElprisReport(),
  staleTime: 30 * 60_000,
});
